import { CommonDataSharedService } from 'app/services/commonDataSharedService';
import { NotificationService } from './../../services/notification.service';
import { CommonAuthenticationService } from './../../services/common-authentication.service';
import { CommonRequestResponseService } from './../../services/common-request-response.service';
import { MenuService } from './../../services/menu.service';
import { Component, Input, OnInit } from '@angular/core';
import { LoginInfoProvider } from '../../ev-dal/login-info.provider';

@Component({
  selector: 'app-coaching-hub',
  templateUrl: './coaching-hub.component.html',
  styleUrls: ['./coaching-hub.component.scss']
})
export class CoachingHubComponent implements OnInit {
  @Input() currentStudentUserId: any;
  @Input() studentPartnerId;
  @Input() studentProfileId;
  currentPageId: string;
  isStudent = false;
  count: number;
  assessmentLabel: string;
  AssessmentFlag: string;
  localData;
  selectedIndex;
  howItWorksData;
  constructor(
    private _menuService: MenuService,
    private authService: LoginInfoProvider,
    private _commonRequestResponseService: CommonRequestResponseService,
    private _commonAuthService: CommonAuthenticationService,
    private notificationService: NotificationService,
    private _commonDataSharedService: CommonDataSharedService
  ) {
    if (!this.studentPartnerId) {
      this.isStudent = this.authService.roleName.toLowerCase() === 'student';
      this.studentPartnerId = this.authService.partnerId;
    }
  }

  ngOnInit() {
    this.localData = JSON.parse(localStorage.getItem('loginUserData'));
    if (this.localData.module.toLowerCase() === 'student') {
      this.assessmentLabel = this.localData.hideAssessment && !this.localData.isWebinarReservation ? 'Career Assessment' : 'Assessments'

    } else {
      const hideAssessment = JSON.parse(localStorage.getItem('studentHideAssessment'));
      const webinarReservation = JSON.parse(localStorage.getItem('isWebinarReservation'));

      this.assessmentLabel = hideAssessment && !webinarReservation ? 'Career Assessment' : 'Assessments'

    }
    //this.AssessmentFlag = JSON.parse(this.localData).hideAssessment;
    if (this.localData.module.toLowerCase() === 'student') { 
      this.getPageData();
    } else {
      this.getHowItWorksData();
    }
    
    this._commonDataSharedService.updateMessageCount.next();
    this._commonDataSharedService.countUpdate.subscribe((countData) => {
      this.getCountValue(countData);
    });

    if (localStorage.getItem('navigateCareer')) {
      this.selectedIndex = 1
    }

  }
  updateMenu() {
    const inputJson = {
      role: this._commonAuthService.getRoleName()
    };
    this._menuService.getMenuData(inputJson, 'parent');
  }

  tabChange(event) {
     if (event.index === 1) {
       this._commonDataSharedService.studentCareerSelect.next(1);
     }
  }
  getPageData() {
      this.currentPageId = this._menuService.getCurrentPageId();
  }

  getHowItWorksData() {
    const inputJson = {
      pageclassid: 48
    };
    this._commonRequestResponseService.postWithHeader('shared/contentdetails/howItWorks', inputJson)
      .subscribe(
      (howItworksJson: any) => {
        this.howItWorksData = howItworksJson;
      },
      () => {
        this.notificationService.show('info', 'Error while getting how it works data');
      });
  }
  
  getCountValue(countData) {
    this.count = countData.coachingHubCount;
  }
}
